import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import Swal from "sweetalert2";
import { decodeAndValidateToken, refreshAccessToken } from "./utils/tokenUtils";

const Context = createContext();

export const ContextProvider = ({ children }) => {
  const [modalStates, setModalStates] = useState({
    cancelPolicy: false,
    terms: false,
    privacy: false,
    editPrivacy: false,
    editTerms: false,
    editCancelPolicy: false,
    emergencyNumber: false,
    rejectUser: false,
    tempBan: false,
    permBan: false,
    delete: false,
    addIncaption: false,
    incaption: false,
    search: false,
    addEditEmployee: false,
    roleDetails: false,
    addEditRole: false,
    viewAd: false,
    addEditAd: false,
    addEditOccation: false,
    addEditReword: false,
    addEditRedemption: false,
    addEditReport: false,
    emergency: false,
    actionDetails: false,
    addComment: false,
    confirm: false,
    transaction: false,
    walletAction: false,
    charge: false,
    walletBill: false,
    cashoutWallet: false,
    noti: false,
    addEditDistput: false,
    addEditSupportType: false,
    supportTypesList: false,
    disputeTypesList: false,
    acceptCarRequest: false,
    employeeReport: false,
    saveReport: false,
    addEditConfig: false,
    manualAdjest: false,
    addEditAppVersion: false,
    appVersionDetails: false,
  });
  const [value, setValue] = useState("");

  const closeModal = useCallback((modal) => {
    setId("");
    handleCloseModal(modal);
  }, []);
  const [quickData, setQuickData] = useState({
    status: "",
    assigned_to: null,
    priority: "",
  });
  const [decisionData, setDecisionData] = useState({
    decision_summary: "",
    penalty_driver: false,
    penalty_passenger: false,
    refund_amount: null,
    is_final: false,
  });
  const [quickDataSupport, setQuickDataSupport] = useState({
    status: "",
    assigned_to: null,
    priority: "",
    channel: "",
  });
  const [manualAdjest, setManualAdjest] = useState({
    delta_points: null,
    reason: "",
  });
  const [note, setNote] = useState({
    ticket_id: null,
    text: "",
    is_internal: true,
  });
  const [earningData, setEarningData] = useState({});
  const [reportData, setReportData] = useState({
    name: "",
    description: "",
    report_type: "",
    time_frame: "",
    file_type: "",
    date_from: "",
    date_to: "",
  });
  const [configData, setConfigData] = useState({
    arName: "",
    enName: "",
    company_id: "",
    is_active: false,
  });
  const [chargeData, setChargeData] = useState({
    name: "",
    balance: "",
    target_user_id: "",
    driver_id: "",
    amount: "",
    currency_id: "",
    payment_method: "",
    office_reference_no: "",
    note: "",
    receipt_image: undefined,
    bill_image: undefined,
  });
  const [adminId, setAdminId] = useState();
  const [reportText, setReportText] = useState();
  const [status, setStatus] = useState("in_progress");
  const [type, setType] = useState("");
  const [imagePreview, setImagePreview] = useState();
  const [number, setNumber] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isTokenChecked, setIsTokenChecked] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [id, setId] = useState("");
  const [selectedSupportType, setSelectedSupportType] = useState(null);
  const [banType, setBanType] = useState("");
  const [edit, setEdit] = useState(false);
  const [tripCommission, setTripCommission] = useState("");

  const [accountData, setAccountData] = useState({
    user_id: null,
    first_name: "",
    middle_name: "",
    last_name: "",
    birth_date: "",
    national_number: "",
    gender: "",
    license_number: "",
    license_expire_date: "",
    mother_name: "",
    identity_id: "",
    address: "",
    nationality: "",
    Identity_registration: "",
  });

  const [comment, setComment] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [tab, setTab] = useState("complainant");
  const [editedCarData, setEditedCarData] = useState({
    model_id: 0,
    company_id: 0,
    manufacture_date: "",
    color_id: "",
    plate_number: "",
    vin_number: "",
    mechanical_number: "",
    exp_mechanical_inseption_date: "",
    seats_number: "",
    model: "",
    fuel_type_id: 0,
    category_id: 0,
    services: [],
    insurance_policy_number: "",
    insurance_provider_id: 0,
    insurance_expire_date: "",
    method: "PUT",
  });

  const [roleData, setRoleData] = useState({
    name: "",
    note: "",
    permissions: [],
  });

  const [employeeData, setEmployeeData] = useState({
    name: "",
    phone_number: "",
    password: "",
    role_id: 0,
    photo: undefined,
    active: 1,
  });

  const [deleteType, setDeleteType] = useState();

  const handleDelete = useCallback((type, id) => {
    setDeleteType(type);
    setId(id);
    handleOpenModal("delete");
  }, []);

  const openModal = useCallback((modal, id, mode) => {
    setId(id);
    handleOpenModal(modal);
    setMode(mode);
  }, []);

  const handleModal = useCallback((modal, id, type) => {
    setId(id);
    handleOpenModal(modal);
    setBanType(type);
  }, []);

  const [tempBan, setTempBan] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
  });

  const [mode, setMode] = useState("");

  const handleError = useCallback((err, defaultTitle = "An error occurred") => {
    const errorData = err.response?.data;
    const title = errorData?.message || err.message || defaultTitle;

    const response = {
      title,
      showConfirmButton: true,
      confirmButtonText: "OK",
    };

    if (errorData?.errors) {
      let errorMessages = [];

      if (Array.isArray(errorData.errors) && errorData.errors.length > 0) {
        errorMessages = errorData.errors.map(
          (error, index) => `<strong>Error ${index + 1}:</strong> ${error}`,
        );
      } else if (
        typeof errorData.errors === "object" &&
        errorData.errors !== null
      ) {
        const keys = Object.keys(errorData.errors);
        if (keys.length > 0) {
          errorMessages = keys.map(
            (key) => `<strong>${key}:</strong> ${errorData.errors[key]}`,
          );
        }
      }

      if (errorMessages.length > 0) {
        response.html = errorMessages.join("<br>");
        response.title = errorData.message || "Validation Error";
      }
    }

    return response;
  }, []);

  const showErrorAlert = useCallback(
    (err, defaultTitle = "An error occurred") => {
      const errorConfig = handleError(err, defaultTitle);
      Swal.fire({
        icon: "error",
        ...errorConfig,
        zIndex: 999999,
        customClass: {
          container: "swal2-error-container",
        },
      });
    },
    [handleError],
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleMenuOpen = useCallback((event, rowIndex) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(rowIndex);
  }, []);

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
    setSelectedRow(null);
  }, []);

  // Add a ref to track initial load
  const initialLoadComplete = useRef(false);

  // Load saved data on app start
  useEffect(() => {
    const savedNumber = localStorage.getItem("rememberedNumber");
    const savedRemember = localStorage.getItem("rememberMe") === "true";

    if (savedRemember && savedNumber) {
      setNumber(savedNumber);
      setRemember(true);
    }

    // Check token validity on initial load
    const initializeAuth = async () => {
      try {
        await checkTokenValidity();
      } catch (error) {
        console.error("❌ Error during initial auth check:", error);
      } finally {
        setIsTokenChecked(true);
        initialLoadComplete.current = true;
      }
    };

    initializeAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // checkTokenValidity is stable, no need to include it

  // Save phone number when "Remember me" is enabled
  useEffect(() => {
    if (remember && number) {
      localStorage.setItem("rememberedNumber", number);
      localStorage.setItem("rememberMe", "true");
    } else if (!remember) {
      localStorage.removeItem("rememberedNumber");
      localStorage.removeItem("rememberMe");
    }
  }, [remember, number]);
  const checkTokenValidity = useCallback(async () => {
    try {
      const token = sessionStorage.getItem("ecoToken");
      const refreshToken = sessionStorage.getItem("ecoRefreshToken");

      console.log("🔍 checkTokenValidity tokens:", {
        hasToken: !!token,
        hasRefreshToken: !!refreshToken,
        tokenLength: token ? token.length : 0,
      });

      if (!token) {
        console.log("❌ No token found in sessionStorage");
        setIsAuthenticated(false);
        return false;
      }

      // Check token validity
      const { isValid, isExpired } = decodeAndValidateToken(token);

      // If token is valid, set authenticated
      if (isValid && !isExpired) {
        const userData = sessionStorage.getItem("userData");
        if (userData) {
          try {
            const parsedUserData = JSON.parse(userData);
            setUser(parsedUserData);
          } catch (parseError) {
            console.error("❌ Error parsing userData:", parseError);
          }
        }
        setIsAuthenticated(true);
        console.log("✅ Token is valid, user authenticated");
        return true;
      }

      // If token is expired but we have refresh token
      if (isExpired && refreshToken) {
        console.log("🔄 Token expired, attempting refresh...");
        try {
          const { accessToken, refreshToken: newRefreshToken } =
            await refreshAccessToken(refreshToken);

          // refreshAccessToken already saves to sessionStorage, but ensure it's saved
          sessionStorage.setItem("ecoToken", accessToken);
          if (newRefreshToken) {
            sessionStorage.setItem("ecoRefreshToken", newRefreshToken);
          }

          // Verify the new token
          const { isValid: newTokenValid, isExpired: newTokenExpired } =
            decodeAndValidateToken(accessToken);

          if (newTokenValid && !newTokenExpired) {
            // Load user data if available
            const userData = sessionStorage.getItem("userData");
            if (userData) {
              try {
                const parsedUserData = JSON.parse(userData);
                setUser(parsedUserData);
              } catch (parseError) {
                console.error(
                  "❌ Error parsing userData after refresh:",
                  parseError,
                );
              }
            }
            setIsAuthenticated(true);
            console.log("✅ Token refreshed successfully");
            return true;
          } else {
            // Token might still be valid on server even if decode says invalid
            // This can happen if server uses different validation
            console.warn(
              "⚠️ Refreshed token decode validation failed, but token exists:",
              {
                isValid: newTokenValid,
                isExpired: newTokenExpired,
                tokenLength: accessToken ? accessToken.length : 0,
              },
            );
            // Still set authenticated since we got a token from server
            // Server will validate on next API call
            const userData = sessionStorage.getItem("userData");
            if (userData) {
              try {
                const parsedUserData = JSON.parse(userData);
                setUser(parsedUserData);
              } catch (parseError) {
                console.error("❌ Error parsing userData:", parseError);
              }
            }
            setIsAuthenticated(true);
            console.log(
              "✅ Token refreshed (server validation will occur on next API call)",
            );
            return true;
          }
        } catch (refreshError) {
          console.error("❌ Failed to refresh token:", refreshError);

          // Check if it's a network error - if so, keep tokens and allow access
          // Server will validate on next API call
          const isNetworkError =
            !refreshError.response &&
            (refreshError.code === "ECONNABORTED" ||
              refreshError.message?.includes("timeout") ||
              refreshError.message?.includes("Network"));

          if (isNetworkError) {
            console.warn(
              "⚠️ Network error during refresh, keeping tokens for retry",
            );
            // Keep existing tokens and allow access - server will validate
            setIsAuthenticated(true);
            return true;
          }

          // Check if it's a 401/403 - refresh token is invalid
          const isAuthError =
            refreshError.response &&
            (refreshError.response.status === 401 ||
              refreshError.response.status === 403);

          if (isAuthError) {
            console.log(
              "❌ Refresh token is invalid (401/403), authentication failed",
            );
            // ❌❌❌ CRITICAL: DO NOT CLEAR TOKENS HERE ❌❌❌
            // Keep the tokens for manual logout
            setIsAuthenticated(false);
            return false;
          }

          // For other errors (500, etc.), be lenient - keep tokens and allow access
          // Server might be having issues, but tokens might still be valid
          console.warn(
            "⚠️ Refresh failed with non-auth error, keeping tokens and allowing access",
          );
          // Load user data if available
          const userData = sessionStorage.getItem("userData");
          if (userData) {
            try {
              const parsedUserData = JSON.parse(userData);
              setUser(parsedUserData);
            } catch (parseError) {
              console.error("❌ Error parsing userData:", parseError);
            }
          }
          setIsAuthenticated(true);
          return true; // Allow access - server will validate on next API call
        }
      }

      // No valid token and no refresh token
      console.log("❌ Token invalid/expired and no refresh token available");
      setIsAuthenticated(false);
      return false; // Just return false, don't clear tokens
    } catch (error) {
      console.error("❌ Error checking token validity:", error);
      setIsAuthenticated(false);
      return false; // Just return false, don't clear tokens
    }
  }, []);

  const logout = useCallback(() => {
    console.log("🚪 Logging out...");
    sessionStorage.removeItem("ecoToken");
    sessionStorage.removeItem("ecoRefreshToken");
    sessionStorage.removeItem("userData");
    setUser(null);
    setIsAuthenticated(false);
    setPassword("");
    window.location.assign("/");
  }, []);

  const [inspection, setInspection] = useState({
    inspection_result: "",
    notes: "",
    photos: [],
  });

  // Save token and refresh token
  const saveToken = useCallback((token, userData, refreshToken = null) => {
    console.log("💾 Saving tokens...");
    sessionStorage.setItem("ecoToken", token);
    if (refreshToken) {
      sessionStorage.setItem("ecoRefreshToken", refreshToken);
    }
    if (userData) {
      sessionStorage.setItem("userData", JSON.stringify(userData));
      setUser(userData);
    }
    setIsAuthenticated(true);
    console.log("✅ Tokens saved, user authenticated");
  }, []);

  // Check if token has been verified
  const isTokenVerified = useCallback(() => {
    return isTokenChecked;
  }, [isTokenChecked]);

  const handleOpenModal = useCallback((modalName) => {
    setModalStates((prev) => ({ ...prev, [modalName]: true }));
  }, []);

  const handleCloseModal = useCallback((modalName) => {
    setModalStates((prev) => ({ ...prev, [modalName]: false }));
  }, []);

  return (
    <Context.Provider
      value={{
        handleCloseModal,
        handleOpenModal,
        modalStates,
        number,
        setNumber,
        password,
        setPassword,
        remember,
        setRemember,
        user,
        setUser,
        isAuthenticated,
        setIsAuthenticated,
        isTokenChecked,
        logout,
        checkTokenValidity,
        saveToken,
        isTokenVerified,
        accountData,
        setAccountData,
        rejectReason,
        setRejectReason,
        id,
        setId,
        selectedSupportType,
        setSelectedSupportType,
        tempBan,
        setTempBan,
        banType,
        setBanType,
        handleModal,
        handleMenuOpen,
        handleMenuClose,
        anchorEl,
        selectedRow,
        showErrorAlert,
        openModal,
        inspection,
        setInspection,
        mode,
        setMode,
        deleteType,
        setDeleteType,
        handleDelete,
        edit,
        setEdit,
        roleData,
        setRoleData,
        imagePreview,
        setImagePreview,
        employeeData,
        setEmployeeData,
        editedCarData,
        setEditedCarData,
        isEditing,
        setIsEditing,
        tripCommission,
        setTripCommission,
        closeModal,
        chargeData,
        setChargeData,
        comment,
        setComment,
        earningData,
        setEarningData,
        type,
        setType,
        tab,
        setTab,
        status,
        setStatus,
        reportText,
        setReportText,
        reportData,
        setReportData,
        configData,
        setConfigData,
        quickData,
        setQuickData,
        decisionData,
        setDecisionData,
        quickDataSupport,
        setQuickDataSupport,
        note,
        setNote,
        adminId,
        setAdminId,
        manualAdjest,
        setManualAdjest,
        value,
        setValue,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export const useMyContext = () => {
  const context = useContext(Context);
  if (context === undefined) {
    throw new Error("useMyContext must be used within a MyProvider");
  }
  return context;
};
